
/* styles */
require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-b78b4740\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../vux-loader/src/after-less-loader.js!less-loader?{\"sourceMap\":true}!../../../../vux-loader/src/style-loader.js!../../../../vue-loader/lib/selector?type=styles&index=0!./index.vue")

var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vux-loader/src/script-loader.js!../../../../vue-loader/lib/selector?type=script&index=0!./index.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-b78b4740\"}!../../../../vux-loader/src/before-template-compiler-loader.js!../../../../vux-loader/src/template-loader.js!../../../../vue-loader/lib/selector?type=template&index=0!./index.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vux/src/components/x-button/index.vue
// module id = 16
// module chunks = 1